module.exports = __webpack_public_path__ + "img/back-icon.b959d81e.png";